import React from 'react';
import { useDeviceManagerState } from 'app/containers/rtc/DeviceManagerContext';
import { ScreenSharingUserAction } from 'app/services/rtc/DisplayMediaSource';
import PersistedScreenSharingRejectionModal
from 'app/components/rtc/ScreenSharingModal/PersistedScreenSharingRejectionModal';

const ScreenSharingModal = () => {
  const { screen } = useDeviceManagerState();

  switch (screen.userAction) {
    case ScreenSharingUserAction.PersistedRejection:
      return <PersistedScreenSharingRejectionModal />;
    default:
      return null;
  }
};

export default ScreenSharingModal;
